/**
 * Interpreta come UTC una data che arriva dall'API.
 *
 * L'API serializza i `DateTime` letti da SQL Server con `Kind = Unspecified`, quindi Newtonsoft
 * li scrive SENZA offset (`2026-09-10T07:05:20.222`). `new Date()` su una stringa cosi' la
 * interpreta come ora LOCALE: su una macchina italiana l'istante slitterebbe di due ore.
 * Aggiungere la `Z` quando manca risolve, e le stringhe che gia' ce l'hanno passano intatte.
 */
function parseUtc(s: string): Date {
    return s.endsWith('Z') ? new Date(s) : new Date(`${s}Z`)
}

/**
 * Data e ora nel fuso italiano, nel formato che si usa in piattaforma (gg/mm/aaaa hh:mm).
 * A DB le date stanno in UTC: la conversione si fa qui, alla visualizzazione.
 */
function formatDateTimeIt(date: Date): string {
    return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Rome',
    })
}

export { parseUtc, formatDateTimeIt }
